exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "card-details{display:block}card-details .details-header-content header{height:30px}card-details .details-header-content header h1{margin:0;font-size:inherit;height:inherit;line-height:32px;text-align:center;background-color:#f2f3f4;border:1px solid #dddfe2;border-top:none}card-details .details-header-content header h1 a{margin-right:8px;font-family:Stag Sans;font-weight:400;color:#0072c9;font-size:15px;text-decoration:none}card-details .details-header-content header h1 a:hover{text-decoration:none;background-color:inherit}card-details .details-header-content header h1 a .icon{font-size:12px;vertical-align:middle;margin-left:6px}card-details .details-content{background-color:#fbfbfb}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/components/cardDetails/cardDetails.scss
// module id = 984
// module chunks = 0